import React, { Component } from 'react';

class ContainerLeft extends Component {
    constructor(props){
        super(props);
        this.state = {
            collLeft: [
                {
                    id: 1,
                    subtitle: 'Topic 1',
                    title: 'Understanding Adaptive Control',
                    text: 'In this chapter, we introduce the concept of adaptive control and how this field is evolving with the integration of neural networks, a key tool for addressing dynamic systems.'
                },
                {
                    id: 2,
                    subtitle: 'Topic 2',
                    title: 'The Evolution of Control Systems',
                    text: 'Discover how control systems have evolved over time, and how adaptive control has emerged as a fundamental solution across various industrial applications.'
                },
                /*{
                    id: 3,
                    subtitle: 'Chapter 3',
                    title: 'The rise of trend Design',
                    text: 'Well-written book is concerned with creating typography and is essential for professionals who regularly '
                }*/
            ]
        }
    }
    render() {
        return (
            <div className="chapter-list border-right-0">
                 {
                    this.state.collLeft.map((data,i) => (
                        <div className="chapter-item" key={i}>
                            <h4><span>{data.subtitle} </span> {data.title}</h4>
                            <p>{data.text} </p>
                        </div>
                    ))
                }
            </div>
        );
    }
}

export default ContainerLeft;
